import { useEffect, useState } from 'react';
// Returns the id of the section currently scrolled past the offset (for the anchored nav).
//
// `offset` is deliberately larger than the sections' `scroll-mt` (scroll-mt-40 = 160px). Clicking a
// nav item scrolls that section so its top lands exactly on its scroll-margin line; if the offset
// equalled it, the comparison would sit on a sub-pixel boundary (`160 - 160 = 0`, but smooth-scroll
// rounding lands at 160.x), so the clicked section would NOT register and the underline indicator
// would stay stuck on the previous section. The extra margin clears that boundary while staying well
// under any section's height, so the next section still doesn't activate early.
export const useScrollSpy = (ids, offset = 200) => {
    const [active, setActive] = useState(ids[0]);
    useEffect(() => {
        const handler = () => {
            var _a;
            // A short final section can't scroll far enough to cross the offset line, so it would never
            // become active. When the page is scrolled to the bottom, treat the last section as active.
            const reachedBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
            if (reachedBottom) {
                setActive((_a = ids[ids.length - 1]) !== null && _a !== void 0 ? _a : ids[0]);
                return;
            }
            let current = ids[0];
            ids.forEach((id) => {
                const el = document.getElementById(id);
                if (el && el.getBoundingClientRect().top - offset <= 0) {
                    current = id;
                }
            });
            setActive(current);
        };
        handler();
        window.addEventListener('scroll', handler, { passive: true });
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('scroll', handler);
            window.removeEventListener('resize', handler);
        };
    }, [ids, offset]);
    return active;
};
